/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CartsRequestBuilderNavigationMetadata, type CartsRequestBuilder } from './carts/index.js';
// @ts-ignore
import { CompanydocsRequestBuilderNavigationMetadata, type CompanydocsRequestBuilder } from './companydocs/index.js';
// @ts-ignore
import { TearsheetsRequestBuilderNavigationMetadata, type TearsheetsRequestBuilder } from './tearsheets/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter
 */
export interface MessagecenterRequestBuilder extends BaseRequestBuilder<MessagecenterRequestBuilder> {
    /**
     * The carts property
     */
    get carts(): CartsRequestBuilder;
    /**
     * The companydocs property
     */
    get companydocs(): CompanydocsRequestBuilder;
    /**
     * The tearsheets property
     */
    get tearsheets(): TearsheetsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MessagecenterRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MessagecenterRequestBuilderNavigationMetadata: Record<Exclude<keyof MessagecenterRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    carts: {
        navigationMetadata: CartsRequestBuilderNavigationMetadata,
    },
    companydocs: {
        navigationMetadata: CompanydocsRequestBuilderNavigationMetadata,
    },
    tearsheets: {
        navigationMetadata: TearsheetsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
